<template>
  <div class="gardenProjectInfo">
    <el-card>
      <div class="jump-btn">
        <el-button type="primary" @click="back">{{$t('lang.btn_wj_returnNews')}}</el-button>
      </div>
      <el-form :model="ruleForm" name="frm" :rules="rules" ref="ruleForm" class="wid100"
        :label-width="require('@/config/enum').c_ws12" :label-suffix="require('@/config/enum').c_colon">
        <el-form-item tem label="建设单位名称" prop="buildUnitName">
          <el-input v-model="ruleForm.buildUnitName" placeholder="请输入建设单位名称" class="item-input" maxlength="50">
          </el-input>
        </el-form-item>
        <el-form-item tem label="物业企业名称" prop="enterpriseName">
          <el-input v-model="ruleForm.enterpriseName" placeholder="请输入物业企业名称" class="item-input" maxlength="50">
          </el-input>
        </el-form-item>
        <el-form-item tem label="项目名称" prop="projectName">
          <el-input v-model="ruleForm.projectName" placeholder="请输入项目名称" class="item-input" maxlength="50">
          </el-input>
        </el-form-item>
        <el-form-item label="项目所在区" prop="administrativeRegion">
          <el-select v-model="ruleForm.administrativeRegion" placeholder="请选择">
            <el-option v-for="item in administrativeRegion" :key="item.value" :value="item.value" :label="item.label">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item tem label="所在街道" prop="belongStreet">
          <el-input v-model="ruleForm.belongStreet" placeholder="请输入所在街道" class="item-input" maxlength="50">
          </el-input>
        </el-form-item>
        <el-form-item tem label="所在社区" prop="belongCommunity">
          <el-input v-model="ruleForm.belongCommunity" placeholder="请输入所在社区" class="item-input" maxlength="50">
          </el-input>
        </el-form-item>
        <el-form-item tem label="项目地址" prop="projectAddress">
          <el-input v-model="ruleForm.projectAddress" placeholder="请输入项目地址" class="item-input" maxlength="50">
          </el-input>
        </el-form-item>
        <el-form-item label="项目类型" prop="projectType">
          <el-select v-model="ruleForm.projectType" placeholder="请选择">
            <el-option v-for="item in projectType" :key="item.value" :value="item.value" :label="item.label">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item tem label="四至范围_东" prop="aroundEast">
          <el-input v-model="ruleForm.aroundEast" placeholder="请输入四至范围_东" class="item-input" maxlength="50">
          </el-input>
        </el-form-item>
        <el-form-item tem label="四至范围_西" prop="aroundWest">
          <el-input v-model="ruleForm.aroundWest" placeholder="请输入四至范围_西" class="item-input" maxlength="50">
          </el-input>
        </el-form-item>
        <el-form-item tem label="四至范围_南" prop="aroundSouth">
          <el-input v-model="ruleForm.aroundSouth" placeholder="请输入四至范围_南" class="item-input" maxlength="50">
          </el-input>
        </el-form-item>
        <el-form-item tem label="四至范围_北" prop="aroundNorth">
          <el-input v-model="ruleForm.aroundNorth" placeholder="请输入四至范围_北" class="item-input" maxlength="50">
          </el-input>
        </el-form-item>
        <el-form-item label="是否有物业" prop="isProperty">
          <el-select v-model="ruleForm.isProperty" placeholder="请选择">
            <el-option value=1 label="是"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否老旧小区" prop="isOld">
          <el-select v-model="ruleForm.isOld" placeholder="请选择">
            <el-option v-for="item in yesorno" :key="item.value" :value="item.value" :label="item.label">
            </el-option>
          </el-select>
          <span style="color:red;margin-left:10px;">2000年6月底之前的为老旧小区</span>
        </el-form-item>
        <el-form-item label="管理模式" prop="managementModel">
          <el-select v-model="ruleForm.managementModel" placeholder="请选择">
            <el-option v-if="ruleForm.isOld==2" value="1" label="专业化物业服务">
            </el-option>
            <el-option v-else v-for="item in managementModel" :key="item.value" :value="item.value" :label="item.label">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否有业主委员会" prop="isOwnerTeam">
          <el-select v-model="ruleForm.isOwnerTeam" placeholder="请选择">
            <el-option v-for="item in yesorno" :key="item.value" :value="item.value" :label="item.label">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item tem label="第几届业主委员会" prop="ownerTeamSecond">
          <el-input v-model="ruleForm.ownerTeamSecond" placeholder="请输入" class="item-input" maxlength="50">
          </el-input>
        </el-form-item>
        <el-form-item label="业主大会执行机构" prop="ownerTeamActuator">
          <el-select v-model="ruleForm.ownerTeamActuator" placeholder="请选择">
            <el-option v-if="ruleForm.isOwnerTeam==1" value="1" label="业主委员会"></el-option>
            <el-option v-else value="2" label="社区代行"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item tem label="项目占地面积(㎡)" prop="projectAllArea">
          <el-input v-model="ruleForm.projectAllArea" placeholder="请输入" class="item-input" type="number" maxlength="50">
          </el-input>
        </el-form-item>
        <el-form-item tem label="项目建筑面积(㎡)" prop="projectBuildArea">
          <el-input v-model="ruleForm.projectBuildArea" placeholder="请输入" class="item-input" type="number"
            maxlength="50">
          </el-input>
        </el-form-item>
        <el-form-item label="竣工备案时间" prop="completedDate">
          <el-date-picker type="date" placeholder="选择日期" v-model="ruleForm.completedDate"></el-date-picker>
        </el-form-item>
        <el-form-item label="开盘日期" prop="sellDate">
          <el-date-picker type="date" placeholder="选择日期" v-model="ruleForm.sellDate"></el-date-picker>
        </el-form-item>
        <el-form-item label="入住时间" prop="checkInDate">
          <el-date-picker type="date" placeholder="选择日期" v-model="ruleForm.checkInDate"></el-date-picker>
        </el-form-item>
        <el-form-item tem label="上一年物业费收取率(%)" prop="lastYearChargeRate">
          <el-input v-model="ruleForm.lastYearChargeRate" placeholder="请输入" class="item-input" maxlength="50">
          </el-input>
          <span style="color:red;margin-left:10px;">只填写数字即可，不需要填写‘%’，例：12.34</span>
        </el-form-item>
        <el-form-item tem label="当年物业费收取率(%)" prop="thisYearChargeRate">
          <el-input v-model="ruleForm.thisYearChargeRate" placeholder="请输入" class="item-input" maxlength="50">
          </el-input>
          <span style="color:red;margin-left:10px;">只填写数字即可，不需要填写‘%’，例：12.34</span>
        </el-form-item>
        <el-form-item tem label="供热公司名称" prop="heatCompanyName">
          <el-input v-model="ruleForm.heatCompanyName" placeholder="请输入" class="item-input" maxlength="50">
          </el-input>
        </el-form-item>
        <el-form-item tem label="热源厂名称" prop="heatSourceName">
          <el-input v-model="ruleForm.heatSourceName" placeholder="请输入" class="item-input" maxlength="50">
          </el-input>
        </el-form-item>
        <el-form-item tem label="换热站名称" prop="heatExchangeStationName">
          <el-input v-model="ruleForm.heatExchangeStationName" placeholder="请输入" class="item-input" maxlength="50">
          </el-input>
        </el-form-item>
        <el-form-item label="小区是否有换热站" prop="isHeatExchangeStation">
          <el-select v-model="ruleForm.isHeatExchangeStation" placeholder="请选择">
            <el-option v-for="item in yesorno" :key="item.value" :value="item.value" :label="item.label">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item tem label="供水公司名称" prop="waterCompanyName">
          <el-input v-model="ruleForm.waterCompanyName" placeholder="请输入" class="item-input" maxlength="50">
          </el-input>
        </el-form-item>
        <el-form-item tem label="供电公司名称" prop="electricCompanyName">
          <el-input v-model="ruleForm.electricCompanyName" placeholder="请输入" class="item-input" maxlength="50">
          </el-input>
        </el-form-item>
        <el-form-item tem label="燃气公司名称" prop="gasCompanyName">
          <el-input v-model="ruleForm.gasCompanyName" placeholder="请输入" class="item-input" maxlength="50">
          </el-input>
        </el-form-item>
        <el-form-item label="是否有垃圾分类设施" prop="isRefuseClassification">
          <el-select v-model="ruleForm.isRefuseClassification" placeholder="请选择">
            <el-option v-for="item in yesorno" :key="item.value" :value="item.value" :label="item.label">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否经过老旧小区改造工程" prop="isOldReform">
          <el-select v-model="ruleForm.isOldReform" placeholder="请选择">
            <el-option v-for="item in yesorno" :key="item.value" :value="item.value" :label="item.label">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否有围墙" prop="isWall">
          <el-select v-model="ruleForm.isWall" placeholder="请选择">
            <el-option v-for="item in yesorno" :key="item.value" :value="item.value" :label="item.label">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否有景观湖" prop="isLake">
          <el-select v-model="ruleForm.isLake" placeholder="请选择">
            <el-option v-for="item in yesorno" :key="item.value" :value="item.value" :label="item.label">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否有凉亭" prop="ispavilion">
          <el-select v-model="ruleForm.ispavilion" placeholder="请选择">
            <el-option v-for="item in yesorno" :key="item.value" :value="item.value" :label="item.label">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否有地下停车场" prop="isUnderPark">
          <el-select v-model="ruleForm.isUnderPark" placeholder="请选择">
            <el-option v-for="item in yesorno" :key="item.value" :value="item.value" :label="item.label">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item tem label="小区简介" prop="communityProfile">
          <el-input v-model="ruleForm.communityProfile" placeholder="请输入" class="item-input" type="textarea"
            :autosize="{ minRows: 4}" maxlength="500"></el-input>
        </el-form-item>
        <!-- 按钮 -->
        <el-button class="btn-first" @click="resetForm('ruleForm')">{{$t('lang.btn_rest')}}</el-button>
        <el-button class="detailbtn" type="primary" :disabled="isDisabled" @click="save('ruleForm')">
          {{$t('lang.btn_save')}}
        </el-button>
      </el-form>
    </el-card>
  </div>
</template>

<script>
  /**
   *@ClassName:gardenProjectInfo
   *@Description:项目小区信息
   *@author:杜斌
   *@Copyright:格众科技
   *@date:2020-02-19
   */
  import {
    mapGetters
  } from 'vuex'
  export default {
    data() {
      return {
        administrativeRegion: this.$i18n.t('lang.administrativeRegion'),
        projectType: this.$i18n.t('lang.projectType'),
        yesorno: this.$i18n.t('lang.yesorno'),
        managementModel: this.$i18n.t('lang.managementModel'),
        isDisabled: true,
        saveData: '',
        id: '',
        rules: {
          buildUnitName: [{
            required: true,
            message: '请输入建设单位名称',
            trigger: 'blur'
          }],
          enterpriseName: [{
            required: true,
            message: '请输入物业企业名称',
            trigger: 'blur'
          }],
          projectName: [{
            required: true,
            message: '请输入项目名称',
            trigger: 'blur'
          }],

          administrativeRegion: [{
            required: true,
            message: '请选择项目所在区',
            trigger: 'change'
          }],
          belongStreet: [{
            required: true,
            message: '请输入所在街道',
            trigger: 'blur'
          }],
          belongCommunity: [{
            required: true,
            message: '请输入所在社区',
            trigger: 'blur'
          }],
          projectAddress: [{
            required: true,
            message: '请输入项目地址',
            trigger: 'blur'
          }],
          projectType: [{
            required: true,
            message: '请选择项目类型',
            trigger: 'change'
          }],
          aroundEast: [{
            required: true,
            message: '请输入四至范围_东',
            trigger: 'blur'
          }],
          aroundWest: [{
            required: true,
            message: '请输入四至范围_西',
            trigger: 'blur'
          }],
          aroundSouth: [{
            required: true,
            message: '请输入四至范围_南',
            trigger: 'blur'
          }],
          aroundNorth: [{
            required: true,
            message: '请输入四至范围_北',
            trigger: 'blur'
          }],
          isProperty: [{
            required: true,
            message: '请选择是否有物业',
            trigger: 'change'
          }],
          isOld: [{
            required: true,
            message: '请选择是否老旧小区',
            trigger: 'change'
          }],
          managementModel: [{
            required: true,
            message: '请选择管理模式',
            trigger: 'change'
          }],
          isOwnerTeam: [{
            required: true,
            message: '请选择是否有业主委员会',
            trigger: 'change'
          }],
          ownerTeamSecond: [{
            required: true,
            message: '请输入第几届业主委员会',
            trigger: 'blur'
          }],
          ownerTeamActuator: [{
            required: true,
            message: '请选择业主大会执行机构',
            trigger: 'change'
          }],
          projectAllArea: [{
            required: true,
            message: '请输入项目占地面积',
            trigger: 'blur'
          }],
          projectBuildArea: [{
            required: true,
            message: '请输入项目建筑面积',
            trigger: 'blur'
          }],
          lastYearChargeRate: [{
            required: true,
            message: '请输入上一年物业费收取率',
            trigger: 'blur'
          }],
          thisYearChargeRate: [{
            required: true,
            message: '请输入当年物业费收取率',
            trigger: 'blur'
          }],
          heatCompanyName: [{
            required: true,
            message: '请输入供热公司名称',
            trigger: 'blur'
          }],
          heatSourceName: [{
            required: true,
            message: '请输入热源厂名称',
            trigger: 'blur'
          }],
          heatExchangeStationName: [{
            required: true,
            message: '请输入换热站名称',
            trigger: 'blur'
          }],
        },
        ruleForm: {
          buildUnitName: '', // 建设单位名称
          enterpriseName: '', // 物业企业名称
          projectName: '', // 项目名称
          administrativeRegion: '', // 项目所在区
          belongStreet: '', // 所在街道
          belongCommunity: '', // 所在社区
          projectAddress: '', // 项目地址
          projectType: '', // 项目类型
          aroundEast: '', // 四至范围_东
          aroundWest: '', // 四至范围_西
          aroundSouth: '', // 四至范围_南
          aroundNorth: '', // 四至范围_北
          isProperty: '1', // 是否有物业
          isOld: 2, // 是否老旧小区
          managementModel: '', // 管理模式
          isOwnerTeam: '', // 是否有业主委员会
          ownerTeamSecond: '', // 第几届业主委员会
          ownerTeamActuator: '', // 业主大会执行机构
          projectAllArea: '', // 项目占地面积
          projectBuildArea: '', // 项目建筑面积
          completedDate: '', // 竣工备案时间
          sellDate: '', // 开盘日期
          checkInDate: '', // 入住时间
          lastYearChargeRate: '', // 上一年物业费收取率
          thisYearChargeRate: '', // 当年物业费收取率
          heatCompanyName: '', // 供热公司名称
          heatSourceName: '', // 热源厂名称
          heatExchangeStationName: '', // 换热站名称
          isHeatExchangeStation: '', // 小区是否有换热站
          waterCompanyName: '', // 供水公司名称
          electricCompanyName: '', // 供电公司名称
          gasCompanyName: '', // 燃气公司名称
          isRefuseClassification: '', // 是否有垃圾分类设施
          isOldReform: '', // 是否经过老旧小区改造工程
          isWall: '', // 是否有围墙
          isLake: '', // 是否有景观湖
          ispavilion: '', // 是否有凉亭
          isUnderPark: '', // 是否有地下停车场
          communityProfile: '', // 小区简介

        },
      }
    },
    watch: {
      ruleForm: {
        handler(newVal, oldVal) {
          // ruleForm数据变化时 会调用此方法
          let tempRule = JSON.stringify(newVal)
          if (tempRule === this.saveData) {
            // 没变
            this.isDisabled = true
          } else {
            // 变了
            this.isDisabled = false
          }
        },
        deep: true,
        immediate: true
      },
    },
    computed: {
      ...mapGetters(['gardenId'])
    },
    created() {
      this.getData()
    },
    methods: {
      // 返回上一级
      back() {
        this.$router.push({
          name: 'projectPortrait'
        })
      },
      // 获取项目小区信息
      getData() {
        let loading = this.$loading()
        this.$get(`/gardenDrawGardenInfo?gardenId=` + this.gardenId).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              console.log(res)
              if (res.list.length > 0) {
                this.ruleForm.buildUnitName = res.list[0].buildUnitName
                this.ruleForm.enterpriseName = res.list[0].enterpriseName
                this.ruleForm.projectName = res.list[0].projectName
                this.ruleForm.administrativeRegion = res.list[0].administrativeRegion
                this.ruleForm.belongStreet = res.list[0].belongStreet
                this.ruleForm.belongCommunity = res.list[0].belongCommunity
                this.ruleForm.projectAddress = res.list[0].projectAddress
                this.ruleForm.projectType = res.list[0].projectType
                this.ruleForm.aroundEast = res.list[0].aroundEast
                this.ruleForm.aroundWest = res.list[0].aroundWest
                this.ruleForm.aroundSouth = res.list[0].aroundSouth
                this.ruleForm.aroundNorth = res.list[0].aroundNorth
                this.ruleForm.isProperty = (res.list[0].isProperty).toString()
                this.ruleForm.isOld = res.list[0].isOld
                this.ruleForm.managementModel = (res.list[0].managementModel).toString()
                this.ruleForm.isOwnerTeam = res.list[0].isOwnerTeam
                this.ruleForm.ownerTeamSecond = res.list[0].ownerTeamSecond
                this.ruleForm.ownerTeamActuator = res.list[0].ownerTeamActuator.toString()
                this.ruleForm.projectAllArea = res.list[0].projectAllArea
                this.ruleForm.projectBuildArea = res.list[0].projectBuildArea
                this.ruleForm.completedDate = res.list[0].completedDate
                this.ruleForm.sellDate = res.list[0].sellDate
                this.ruleForm.checkInDate = res.list[0].checkInDate
                this.ruleForm.sellDate = res.list[0].sellDate
                this.ruleForm.lastYearChargeRate = res.list[0].lastYearChargeRate
                this.ruleForm.thisYearChargeRate = res.list[0].thisYearChargeRate
                this.ruleForm.heatCompanyName = res.list[0].heatCompanyName
                this.ruleForm.heatSourceName = res.list[0].heatSourceName
                this.ruleForm.heatExchangeStationName = res.list[0].heatExchangeStationName
                this.ruleForm.isHeatExchangeStation = res.list[0].isHeatExchangeStation
                this.ruleForm.waterCompanyName = res.list[0].waterCompanyName
                this.ruleForm.electricCompanyName = res.list[0].electricCompanyName
                this.ruleForm.gasCompanyName = res.list[0].gasCompanyName
                this.ruleForm.isRefuseClassification = res.list[0].isRefuseClassification
                this.ruleForm.isOldReform = res.list[0].isOldReform
                this.ruleForm.isWall = res.list[0].isWall
                this.ruleForm.isLake = res.list[0].isLake
                this.ruleForm.ispavilion = res.list[0].ispavilion
                this.ruleForm.isUnderPark = res.list[0].isUnderPark
                this.ruleForm.communityProfile = res.list[0].communityProfile
                this.id = res.list[0].id
                // 这是用来保存数据 用来保存就一进来取到的数据，不会去修改它
                this.saveData = JSON.stringify(this.ruleForm)
                console.log(this.ruleForm)
              }
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          })
      },
      // 保存
      save(formName) {
        let params = this.ruleForm
        params.gardenId = this.gardenId
        console.log('params', params)
        this.$refs[formName].validate((valid) => {
          if (valid) {
            let loading = this.$loading()
            if (!this.id) {
              // 新增
              this.$post('/gardenDrawGardenInfo', params).then(
                res => {
                  loading.close()
                  console.log(res)
                  if (res && res.errCode === 0) {
                    this.$message.success(this.$i18n.t('lang.lab_save_success'))
                    this.isDisabled = true
                  }
                },
                error => {
                  loading.close()
                  this.$message.error(error)
                }
              )
            } else {
              // 编辑
              this.$patch(`/gardenDrawGardenInfo/${this.id}`, params).then(
                res => {
                  loading.close()
                  console.log(res)
                  if (res && res.errCode === 0) {
                    this.$message.success(this.$i18n.t('lang.lab_save_success'))
                    this.isDisabled = true
                  }
                },
                error => {
                  loading.close()
                  this.$message.error(error)
                }
              )
            }
          } else {
            return false
          }
        })
      },
      // 清空
      resetForm(formName) {
        this.ruleForm.buildUnitName = ''
        this.ruleForm.enterpriseName = ''
        this.ruleForm.projectName = ''
        this.ruleForm.administrativeRegion = ''
        this.ruleForm.belongStreet = ''
        this.ruleForm.belongCommunity = ''
        this.ruleForm.projectAddress = ''
        this.ruleForm.projectType = ''
        this.ruleForm.aroundEast = ''
        this.ruleForm.aroundWest = ''
        this.ruleForm.aroundSouth = ''
        this.ruleForm.aroundNorth = ''
        this.ruleForm.isProperty = '1'
        this.ruleForm.isOld = 2
        this.ruleForm.managementModel = ''
        this.ruleForm.isOwnerTeam = ''
        this.ruleForm.ownerTeamSecond = ''
        this.ruleForm.ownerTeamActuator = ''
        this.ruleForm.projectAllArea = ''
        this.ruleForm.projectBuildArea = ''
        this.ruleForm.completedDate = ''
        this.ruleForm.sellDate = ''
        this.ruleForm.checkInDate = ''
        this.ruleForm.sellDate = ''
        this.ruleForm.lastYearChargeRate = ''
        this.ruleForm.thisYearChargeRate = ''
        this.ruleForm.heatCompanyName = ''
        this.ruleForm.heatSourceName = ''
        this.ruleForm.heatExchangeStationName = ''
        this.ruleForm.isHeatExchangeStation = ''
        this.ruleForm.waterCompanyName = ''
        this.ruleForm.electricCompanyName = ''
        this.ruleForm.gasCompanyName = ''
        this.ruleForm.isRefuseClassification = ''
        this.ruleForm.isOldReform = ''
        this.ruleForm.isWall = ''
        this.ruleForm.isLake = ''
        this.ruleForm.ispavilion = ''
        this.ruleForm.isUnderPark = ''
        this.ruleForm.communityProfile = ''
      }

    },
  }
</script>

<style lang="scss">
  .gardenProjectInfo {

    .item-input,
    .el-select,
    .el-date-editor.el-input {
      width: 30%;
    }

    .editor-width {
      width: 80%;
    }

    .item-select {
      display: inline-block
    }

    .empty-input {
      display: none
    }
  }
</style>